import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import ProductCardStyles from '@stories/Components/Cards/ProductCard/ProductCard.styles';
import MortgagesProductFiltersStyles from '@stories/Components/Listings/MortgageProductFilters/MortgageProductFilters.styles';
import CheckboxListStyles from '@stories/Components/Misc/Forms/Inputs/CheckboxList/CheckboxList.styles';
import styled, { css } from 'styled-components';
import NavigationStyles from '../Global/Navigation/Navigation.styles';
import ProductListingSavingsStyles from '../ProductListingSavings/ProductListingSavings.styles';
const centralCardGridStyles = css `
  --widthModifier: ${fluid(64, 147)};

  grid-column: 1 / -1;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / -3;

    width: calc(100% + var(--widthModifier));
    margin-left: calc(var(--widthModifier) * -0.5);
  }
`;
const FilterTray = styled(ProductListingSavingsStyles.FilterTray) `
  ${MortgagesProductFiltersStyles.Container} {
    height: 100%;
  }
`;
const Container = styled(ProductListingSavingsStyles.Container) `
  ${ButtonStyles.Container}[data-filter-btn] {
    --borderColour: ${brand.green.default};
  }

  &:not(:has(${FilterTray})) {
    ${ProductCardStyles.Container} {
      ${centralCardGridStyles};
    }
  }
`;
const FilterTrayBackdrop = styled(NavigationStyles.Backdrop) `
  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const FiltersInner = styled(ProductListingSavingsStyles.FiltersInner) `
  ${CheckboxListStyles.Container} {
    flex-direction: row;
  }
`;
const BackButton = styled(ProductListingSavingsStyles.BackButton) ``;
const ButtonIcon = styled(ProductListingSavingsStyles.ButtonIcon) `
  --bgColour: ${brand.green.default};
`;
const Pagination = styled(ProductListingSavingsStyles.Pagination) ``;
const NoResultsText = styled(ProductListingSavingsStyles.NoResultsText) `
  ${Container}:not(:has(${FilterTray})) & {
    ${centralCardGridStyles};
  }
`;
const ProductListingMortgagesStyles = {
    BackButton,
    ButtonIcon,
    Container,
    FiltersInner,
    FilterTray,
    FilterTrayBackdrop,
    NoResultsText,
    Pagination,
};
export default ProductListingMortgagesStyles;
